module.exports = __webpack_public_path__ + "static/media/sf-test-6.73ccd653.mp3";